import React, { forwardRef, useCallback, useEffect, useRef } from 'react';
import { mainBarPropTypes } from './MainBarPropTypes';
import Hamburger from './components/Hamburger/Hamburger';
import Nav from './components/Nav/Nav';
import Logo from './components/Logo/Logo';
import HeaderItemsCollection from './components/HeaderItemsCollection/HeaderItemsCollection';
import SearchResults from './components/SearchResults/SearchResults';
import * as styles from './MainBar.module.scss';
const MainBar = /*#__PURE__*/forwardRef(({
  nav,
  logo,
  searchBar,
  headerItemsCollection,
  onChange,
  isMobileOpen,
  handleOpenMobile,
  setIsSearching,
  isSearching,
  searchResults,
  searchTerm,
  sendSearchData,
  headerRef,
  hasScrolled
}, ref) => {
  if (!nav && !logo && !searchBar && !headerItemsCollection) {
    return null;
  }
  const searchResultsRef = useRef(null);
  const toggleSearch = useCallback(() => {
    setIsSearching(prev => {
      const next = !prev;
      if (!prev && isMobileOpen) {
        handleOpenMobile();
      }
      return next;
    });
  }, [handleOpenMobile, isMobileOpen, setIsSearching]);
  useEffect(() => {
    if (isSearching) {
      var _searchResultsRef$cur, _searchResultsRef$cur2;
      (_searchResultsRef$cur = searchResultsRef.current) === null || _searchResultsRef$cur === void 0 ? void 0 : (_searchResultsRef$cur2 = _searchResultsRef$cur.focusInput) === null || _searchResultsRef$cur2 === void 0 ? void 0 : _searchResultsRef$cur2.call(_searchResultsRef$cur);
    }
  }, [isSearching]);

  /**
   /* Prop objects with data, functions and states
   */
  const navProps = {
    ...nav,
    isMobileOpen,
    isSearching
  };
  const hamburgerProps = {
    isMobileOpen,
    onClick: handleOpenMobile
  };
  const headerItemsCollectionProps = {
    items: headerItemsCollection === null || headerItemsCollection === void 0 ? void 0 : headerItemsCollection.map(item => {
      if ((item === null || item === void 0 ? void 0 : item.type) !== 'search') {
        return item;
      }
      const defaultLabel = item.label || 'Szukaj';
      const closeLabel = (searchBar === null || searchBar === void 0 ? void 0 : searchBar.closeLabel) || 'Zamknij';
      const updatedTitle = isSearching ? closeLabel : item.title || defaultLabel;
      const activeIconName = (searchBar === null || searchBar === void 0 ? void 0 : searchBar.closeIconName) || 'searchClose';
      return {
        ...item,
        label: isSearching ? closeLabel : defaultLabel,
        title: updatedTitle,
        href: undefined,
        iconName: isSearching ? activeIconName : item.iconName
      };
    }),
    expandAndFocusSearchBar: toggleSearch
  };
  const searchResultsProps = {
    searchResults,
    isSearching,
    setIsSearching,
    searchTerm,
    sendSearchData,
    placeholder: searchBar === null || searchBar === void 0 ? void 0 : searchBar.placeholder,
    onChange,
    popularSearches: searchResults === null || searchResults === void 0 ? void 0 : searchResults.popularSearches
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${isSearching ? styles.rootSearching : ''} ${hasScrolled ? styles.rootScrolled : ''} ${isMobileOpen ? styles.rootMobileOpen : ''}`,
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContainer
  }, /*#__PURE__*/React.createElement(Hamburger, Object.assign({}, hamburgerProps, {
    classname: styles.rootHamburger
  })), /*#__PURE__*/React.createElement(Nav, navProps), /*#__PURE__*/React.createElement(Logo, Object.assign({}, logo, {
    classname: styles.rootLogo
  })), /*#__PURE__*/React.createElement(HeaderItemsCollection, headerItemsCollectionProps))), searchResults && /*#__PURE__*/React.createElement(SearchResults, Object.assign({}, searchResultsProps, {
    ref: searchResultsRef
  })));
});
MainBar.displayName = 'MainBar';
export default MainBar;